import { useTheme, jsx } from '@emotion/react';
import 'react';
import ToggleButton from 'react-toggle-button';
import Style from './style.js';

var toggleInputStyles = {
  margin: '0',
  height: '24px',
  width: '40px',
  position: 'absolute'
};
/**
 * The `<Toggle>` component is usually wrapped in a `container` element (with a fixed `width` style for example).
 * The toggle and label are spread in the container (`space-between`) from edge to edge.
 */

var Toggle = _ref => {
  var {
    checked = false,
    label = '',
    onChange
  } = _ref;
  var theme = useTheme();
  return jsx(Style.Container, null, label && jsx(Style.Label, {
    onClick: onChange
  }, label), jsx(Style.ReactToggleButtonContainer, null, jsx(ToggleButton, {
    value: checked || false,
    onToggle: onChange,
    inactiveLabel: "",
    activeLabel: "",
    thumbStyle: Style.thumbStyle(theme),
    trackStyle: Style.trackStyle,
    thumbAnimateRange: [1, 17],
    colors: {
      active: {
        base: theme.COLORS.secondary
      },
      inactive: {
        base: theme.COLORS.defaultBorder
      },
      activeThumb: {
        base: theme.COLORS.white
      },
      inactiveThumb: {
        base: theme.COLORS.white
      }
    },
    passThroughInputProps: {
      style: toggleInputStyles
    }
  })));
};

export { Toggle };
